<div
  class="row"
  *ngIf="!pageConfig?.isVisibleAuditPage && !pageConfig?.isVisibleHelpPage"
>
  <!-- sms template group -->
  <div class="md:tw-w-1/2 tw-pl-0">
    <app-page-template
      [showParent]="showParent"
      (clearQueryString)="onClearQueryString()"
      [config]="pageConfig"
      (onAdd)="onCreate('', true)"
      (sortObject)="getSortItems($event)"
      (onShowAuditPage)="onShowAuditPage()"
      (onShowHelpPage)="onShowHelpPage()"
      (comparisonObjects)="getComparisonObjects($event)"
      (pageNumber)="changePageNumber($event)"
      (pageSize)="changePageSize($event)"
    >
      <!---------------------------------------- Table Content --------------------------------------->
      <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
        <ng-container *ngFor="let item of items$ | async; let i = index">
          <tr
            #row
            (click)="onActiveRow(row, i)"
            [class]="i == 0 ? 'row-active' : ''"
          >
            <!-- index -->
            <td (click)="onSelect(item)" class="tw-text-center !tw-p-4">
              {{ paginationModel?.firstIndex + i }}
            </td>

            <!-- id -->
            <td (click)="onSelect(item)">
              <td-value
                type="number"
                copyToClipboard
                [value]="item?.id"
              ></td-value>
            </td>

            <!-- title -->
            <td (click)="onSelect(item)">
              <td-value copyToClipboard [value]="item?.title"></td-value>
            </td>

            <!------------------------------- operations -------------------------------->
            <td class="sticky-td">
              <app-table-operations
                [model]="item"
                (onDelete)="
                  onDelete(
                    item.id,
                    'messages.confirmByWritingTextMessage',
                    true
                  )
                "
                (onUpdate)="onUpdate(item)"
              >
              </app-table-operations>
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </app-page-template>
  </div>

  <!------------------------- voice messages list ------------------------->
  <div class="md:tw-w-1/2 border-right tw-pr-0">
    <app-voice-messages [group]="selectedItem"> </app-voice-messages>
  </div>
</div>

<!--------------------- Audit smsTemplateGroup --------------------->
<!-- <ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    methodName="smsTemplateGroupsGetSmsTemplateGroupsAudit"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container> -->

<!--------------------------------------- help --------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="'VoiceMessagesList'"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
